import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            alignItems: 'center',
        },

        flexContainer: {
            direction: {base: 'column-reverse', lg: 'row'},
            overflow: 'hidden',
            borderRadius: remCalc(4),
            bg: 'background.default',
            boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
            marginBottom: {base: remCalc(8), lg: remCalc(0)},
        },

        textContent: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: {base: 'stretch', lg: 'center'},
            p: remCalc(16),
            flex: '1',
            gap: remCalc(12),
            textStyle: 'body-xsmall',
            alignContent: 'center',
        },
        textContainer: {
            gap: ['micro.base', 'micro.sm', 'micro.md', 'micro.lg'],
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        tagContainer: {
            bg: 'background.light-blue',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: remCalc(6),
            px: remCalc(8),
            width: 'fit-content',
        },

        tagText: {
            color: 'text.primary',
            fontWeight: 'bold',
            textStyle: 'body-xxsmall',
            textTransform: 'uppercase',
            position: 'relative',
            top: remCalc(2),
        },
        imageContent: {
            position: 'relative',
            width: {base: '100%', lg: remCalc(154)},
            alignContent: 'center',
            height: {base: remCalc(160), lg: 'auto'},
        },
        /*         imageContent: {
            flex: {base: '1 1 100%', lg: '0 0 33%'},
            maxWidth: {base: '100%', lg: '33%'},
        }, */

        title: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'text.primary',
        },

        description: {
            textStyle: 'body-xsmall',
        },

        bannerLink: {
            textDecoration: 'underline',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
        },

        codeContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            borderRadius: remCalc(8),
            maxWidth: remCalc(168),
            paddingY: remCalc(6),
            paddingX: remCalc(8),
            gap: remCalc(12),
            color: 'text.primary',
            width: 'fit-content',
            border: '1px solid',
            borderColor: 'text.primary',
        },

        tagCodeContainer: {
            marginBottom: remCalc(12),
        },

        promoCodeContainer: {
            marginTop: remCalc(12),
        },

        codeText: {
            alignSelf: 'flex-end',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },

        copyIcon: {
            boxSize: 'iconsSize.small',
            verticalAlign: 'middle',
        },

        image: {
            position: 'relative',
            objectFit: 'cover',
            objectPosition: 'top center',
            width: '100%',
            height: {base: remCalc(160), lg: '100%'},
        },
        mobileBannerBlock: {
            display: {base: 'flex', lg: 'none'},
            width: '100%',
            flexDirection: 'column',
        },
        desktopBannerBlock: {
            display: {base: 'none', lg: 'flex'},
            width: '100%',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        accordionBox: {
            borderRadius: remCalc(4),
            border: 'small',
            borderColor: 'border.pdp-banner-mobile',
            width: '100%',
            gap: remCalc(10),
            padding: `${remCalc(8)} ${remCalc(16)} `,
            display: 'flex',
            alignItems: 'center',
        },
        accordion: {
            margin: 0,
            padding: 0,
            border: 'none',
            boxShadow: 'none',
            width: '100%',
        },
        accordionItem: {margin: 0, padding: 0, border: 'none', boxShadow: 'none'},
        accordionButton: {
            margin: 0,
            padding: 0,
            border: 'none',
            boxShadow: 'none',
            alignItems: 'center',
        },
        accordionPanel: {
            margin: 0,
            marginTop: remCalc(16),
            padding: 0,
            border: 'none',
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(8),
        },
        accordionButtonText: {
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'border.pdp-banner-mobile',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
}
